import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, styled, Chip, Dialog, DialogTitle, DialogContent, Button, IconButton, Autocomplete, TextField, Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase'; // Ensure this is the correct path to your firebase setup
import { doc, onSnapshot } from 'firebase/firestore';
import axios from 'axios'; // Make sure axios is imported
import SyncRoundedIcon from '@mui/icons-material/SyncRounded';
import CloseIcon from '@mui/icons-material/Close';
import { setDoc } from 'firebase/firestore';


const CustomBox = styled(Box)(({ theme }) => ({
  borderRadius: '20px',
  margin: 'auto',
  maxWidth: '100%',
  padding: '30px',
  border: '1px solid #F5F5F5',
  transition: '0.3s',
  '&:hover': {
    boxShadow: '0px 3px 6px rgba(255, 76, 21, 1)'
,
  },
}));

const styleOptions = [
  { label: '3D Model', id: '3D_Model' },
  { label: 'Analog', id: 'Analog' },
  { label: 'Anime', id: 'Anime' },
  { label: 'Comic Book', id: 'Comic_Book' },
  { label: 'Cyberpunk', id: 'Cyberpunk' },
  { label: 'Digital Art', id: 'Digital_Art' },
  { label: 'Fantasy Art', id: 'Fantasy_Art' },
  { label: 'Line Art', id: 'Line_Art' },
  { label: 'Origami', id: 'Origami' },
  { label: 'Synthwave', id: 'Synthwave' },
  { label: 'Photorealistic', id: 'Photorealistic' },
  { label: 'Pixel Art', id: 'Pixel_Art' },
  // You can add more style options here as needed
];

function Home() {
  const navigate = useNavigate();
  const [designs, setDesigns] = useState([]);
  const [open, setOpen] = useState(false);
  const [productType] = useState('');
  const [styleTypes, setStyleTypes] = useState([]);
  const [themeType, setThemeType] = useState('');
  const [colorChoice, setColorChoice] = useState('');
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  
  
  // Fetch Designs Function
  const fetchDesigns = async (uid) => {
    setLoading(true);
    console.log("THIS SHOULD BE API CALL:")
    console.log(process.env);
    console.log(process.env.REACT_APP_GENERATE_RECOMMENDATIONS_API);
    try {
      console.log(process.env.REACT_APP_GENERATE_RECOMMENDATIONS_API);
      const response = await axios.post( process.env.REACT_APP_GENERATE_RECOMMENDATIONS_API, { uid });
      if (response.data && response.data.recommendations) {
        setDesigns(response.data.recommendations);
      } else {
        setDesigns([]); // Ensure designs is always an array
      }
      setError(null);
    } catch (error) {
      console.error('Error fetching design recommendations:', error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const saveBrandDataToFirestoreAndGenerateRecommendations = async () => {
    if (!auth.currentUser) {
      console.error('No authenticated user found');
      return;
    }
  
    setLoading(true); // Start loading state
    const uid = auth.currentUser.uid;
    const brandRef = doc(db, 'users', uid);
  
    try {
      await setDoc(brandRef, {
        brandData: {
          productType,
          styleTypes: styleTypes.map(style => style.label),
          themeType,
          colorChoice,
        }
      }, { merge: true });
  
      console.log('Brand data saved successfully');
      setOpen(false); // Close the dialog right after saving brand data successfully
      console.log("UID:", uid);
      await fetchDesigns(uid); // After saving, fetch designs
    } catch (error) {
      console.error('Error in processing', error);
    } finally {
      setLoading(false); // End loading state
    }
  };
  



  useEffect(() => {
    setLoading(true); // Start loading as soon as this effect runs
    const user = auth.currentUser;
    if (user) {
      const userRef = doc(db, 'users', user.uid);
      
      const unsubscribe = onSnapshot(userRef, (doc) => {
        const userData = doc.data();
        if (userData && userData.recommendations && userData.recommendations.length > 0) {
          setDesigns(userData.recommendations);
        } else {
          console.log("No recommendations found or user data does not have recommendations");
          setDesigns([]);
        }
        setLoading(false); // Data has been fetched, so loading is complete
      }, 
      (error) => {
        console.error("Error fetching real-time updates:", error);
        setError(error);
        setLoading(false);
      });
  
      return () => unsubscribe(); // Cleanup
    } else {
      setLoading(false); // If no user is found, ensure loading is set to false
    }
  }, [setError]); // If the user changes, this effect should re-run
  
  

  const handleClick = (design) => {
    navigate('/designs', { state: { design } });
  };

  return (
    <div>
      <Box sx={{ width: '100%', flexGrow: 1 }}>
        <h1>Welcome to Droyd.</h1>
        <Typography variant="subtitle1" sx={{ marginBottom: '20px' }}>
          Need inspiration? Click any of the prompts below to generate a trendy, on-brand design.
        </Typography>
        <Box sx={{ height: '70vh', overflowY: 'auto', padding:'20px' }}>
        <Grid container spacing={3}>
          {designs.length > 0 ? designs.map((design) => (
            <Grid item xs={12} sm={4} md={4} key={design.id}>
              <CustomBox onClick={() => handleClick(design)} style={{cursor: 'pointer'}}>
              <Typography variant="h6" sx={{ marginBottom: '5px' }} fontWeight='bold'>
                {loading ? <Skeleton animation="wave" variant="rounded" width="100%" /> : design.prompt}
              </Typography>
              {loading ? (
                <Skeleton animation="wave" variant="rounded" width="100%" height={24} sx={{ marginBottom: '10px' }} />
              ) : (
                <Typography variant='body2' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                  Style: <Chip label={design.style}/>
                </Typography>
              )}
              {loading ? (
                <Skeleton animation="wave" variant="rounded" width="100%" height={24} />
              ) : (
                <Typography variant='body2' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  Main Color: <Chip label={design.main_color} />
                </Typography>
              )}

              </CustomBox>
            </Grid>
          )) : <Typography variant="h6" sx={{ margin: 'auto' }}>{loading ? <Skeleton width="100%" /> : 'No designs found.'}</Typography>}
        </Grid>
        </Box>

        <Button
          onClick={() => setOpen(true)}
          variant="contained"
          startIcon={<SyncRoundedIcon />}
          sx={{
            backgroundColor: '#ff4c15',
            padding:'10px',
            position: 'fixed',
            bottom: '50px',
            right: '100px',
            borderRadius: '10px', // Keep the button rounded
            boxShadow: '0 0 50px 10px rgba(255, 76, 21, 0.5)',
            ':hover': {
              backgroundColor: '#ff4c15', // Adjust for hover state
            },
            // Adjust other styles as needed
          }}
        >
          Regenerate
        </Button>
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth={true} sx={{ '& .MuiDialog-paper': { width: '50%', height: 'auto', margin: 'auto', borderRadius: '20px' } }}>
          <DialogTitle sx={{ padding: '50px', fontWeight: 'bold' }}>
            Generate Recommendations
            <IconButton
              aria-label="close"
              onClick={() => setOpen(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ padding: '50px' }}>

              {/* Style Types Section */}
              <Typography variant="h8" sx={{ width: '100%', textAlign: 'left', marginBottom: '10px', fontWeight: 'bold' }}>
                What <span style={{ color: '#ff4c15ff' }}>styles</span> should your designs have?
              </Typography>
              <Autocomplete
                multiple
                value={styleTypes}
                onChange={(event, newValue) => {
                  setStyleTypes(newValue);
                }}
                options={styleOptions}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => <TextField {...params} size="small"/>}
                sx={{
                  width: '100%',
                  marginTop:'10px',
                  marginBottom: '20px',
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F5F5F5',
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'transparent',
                    },
                  },
                }}
              />

              {/* Theme Type Section */}
              <Typography variant="h8" sx={{ width: '100%', textAlign: 'left', marginBottom: '10px', fontWeight: 'bold' }}>
                What <span style={{ color: '#ff4c15ff' }}>themes</span> do you envision?
              </Typography>
              <TextField
                value={themeType}
                onChange={(e) => setThemeType(e.target.value)}
                placeholder='e.g., Cars, Christmas, Animals, Robots, Cowboys...'
                fullWidth
                size="small"
                sx={{
                  width: '100%',
                  marginTop:'10px',
                  marginBottom: '20px',
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F5F5F5',
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'transparent',
                    },
                  },
                }}
              />

              {/* Color Choice Section */}
              <Typography variant="h8" sx={{ width: '100%', textAlign: 'left', marginBottom: '10px', fontWeight: 'bold' }}>
                Preferred <span style={{ color: '#ff4c15ff' }}>colors</span> for your designs?
              </Typography>
              <TextField
                value={colorChoice}
                onChange={(e) => setColorChoice(e.target.value)}
                placeholder="e.g., Red, Blue, Black, White"
                fullWidth
                size="small"
                sx={{
                  width: '100%',
                  marginTop:'10px',
                  marginBottom: '20px',
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F5F5F5',
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'transparent',
                    },
                  },
                }}
              />

            <Button
              onClick={saveBrandDataToFirestoreAndGenerateRecommendations}
              variant="contained"
              startIcon={<SyncRoundedIcon />}
              sx={{
                backgroundColor: '#ff4c15',
                padding:'10px',
                position: 'fixed',
                bottom: '50px',
                right: '100px',
                borderRadius: '10px', // Keep the button rounded
                boxShadow: '0 0 50px 10px rgba(255, 76, 21, 0.5)',
                ':hover': {
                  backgroundColor: '#ff4c15', // Adjust for hover state
                },
                // Adjust other styles as needed
              }}
            >
              Regenerate
            </Button>

          </DialogContent>
        </Dialog>



      </Box>
    </div>
  );
}

export default Home;
